import React from "react";
import ContractsPage from "@/components/contracts/ContractsPage";
export default function PublisherContracts() { return <ContractsPage role="publisher" title="Contracts" />; }
